<script>
import AutoSuggestMobile from "@/containers/auto-suggest/auto-suggest-panel";
import Button from "@/components/atoms/button";
import SearchBar from "@/containers/auto-suggest/auto-suggest-search-bar";
import Popin from "@/components/molecules/popin";

export default {
  components: {
    SearchBar,
    AutoSuggestMobile,
    Button,
    Popin
  },
  data() {
    return {
      searchKeyWord: "",
      hasFocus: false
    };
  },
  computed: {
    showResults() {
      return this.searchKeyWord !== "" && this.hasFocus;
    }
  },
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      this.$refs.popin.hide();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    page
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Suggestions"
    :focus-on-opener-when-closed="false"
  >
    <div class="c-auto-suggest-popin u-pt-sm">
      <div class="c-auto-suggest-popin__wrapper">
        <div class="c-auto-suggest-popin__header">
          <SearchBar
            ref="searchBar"
            v-model="searchKeyWord"
            toggle-reset-search
            @focus="hasFocus = true"
            @blur="hasFocus = false"
            class="c-auto-suggest-popin__search-bar"
          />
          <Button
            link
            class="u-ml-sm"
            @click="hide()"
          > Fermer </Button>
        </div>

        <div
          class="c-auto-suggest-popin__content"
          @touchstart="$refs.searchBar.blur()"
        >
          <AutoSuggestMobile is-open />
        </div>
      </div>
    </div>
  </Popin>
</template>

<style scoped lang="scss">
.c-auto-suggest-popin {
  position: relative;
  background-color: white;
  padding: 0;
}

.c-auto-suggest-popin__wrapper {
  position: relative;
  background-color: white;
  z-index: zIndex(header_top);
}
.c-auto-suggest-popin__content {
}
.c-auto-suggest-popin__header {
  display: flex;
  position: sticky;
  top: 0;
  padding: spacing(xs) spacing(sm);
  background-color: white;
  border-bottom: 1px solid color(border);
  z-index: zIndex(above);
}
.c-auto-suggest-popin__search-bar {
  flex: 1;
}
</style>
